import type * as yup from 'yup';

import { campSchema } from '@/features/Sparten/camp/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = campSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

export const useCampInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'CampInputStore',
);
